import React, { Component } from 'react';
import PropTypes from 'prop-types';
import loadingType from './loadingType';
export default class FadingCircleSpinner extends Component {
  static propTypes = {
    selectedLoading: PropTypes.string.isRequired,
    changeSelectedLoading: PropTypes.func.isRequired,
  };

  render() {
    const { selectedLoading, changeSelectedLoading } = this.props;
    const { key, value } = loadingType.FADING_CIRCLE_SPINNER;
    return (
      <div
        className={`col-md-3 col-lg-3 col-xs-3 col-sm-3 text-center ${selectedLoading === key &&
          'border-2 border-success'}`}
      >
        <div className="card pt-3">
          <div className="sk-fading-circle">
            <div className="sk-circle1 sk-circle"></div>
            <div className="sk-circle2 sk-circle"></div>
            <div className="sk-circle3 sk-circle"></div>
            <div className="sk-circle4 sk-circle"></div>
            <div className="sk-circle5 sk-circle"></div>
            <div className="sk-circle6 sk-circle"></div>
            <div className="sk-circle7 sk-circle"></div>
            <div className="sk-circle8 sk-circle"></div>
            <div className="sk-circle9 sk-circle"></div>
            <div className="sk-circle10 sk-circle"></div>
            <div className="sk-circle11 sk-circle"></div>
            <div className="sk-circle12 sk-circle"></div>
          </div>
          <div className="form-check">
            <label className="form-check-label">
              <input
                className="form-check-input"
                type="radio"
                value={key}
                checked={selectedLoading === key}
                onChange={() => changeSelectedLoading(key)}
              />
              {value}
              <span className="circle">
                <span className="check"></span>
              </span>
            </label>
          </div>
        </div>
      </div>
    );
  }
}
